import { z } from "zod"

export const infraredFlightOptions = z.object({
    hotspotPoints: z.boolean().optional(),
    perimeter: z.boolean().optional(),
    flightPath: z.boolean().optional(),
    images: z.boolean().optional(),
    ortho: z.boolean().optional(),
    orthoKmz: z.boolean().optional(),
})

export const orthoFlightOptions = z.object({
    flightPath: z.boolean().optional(),
    images: z.boolean().optional(),
    ortho: z.boolean().optional(),
    orthoKmz: z.boolean().optional(),
    perimeter: z.boolean().optional(),
})

export const transferableRenderOptions = z.object({
    disableLabels: z.boolean().optional(),
})

export type TransferableRenderOptions = z.infer<typeof transferableRenderOptions>

export const infraredFlight = z.object({
    type: z.literal("infraredFlight"),
    id: z.string(),
    include: infraredFlightOptions,
    options: transferableRenderOptions.optional(),
})

export const orthoFlight = z.object({
    type: z.literal("orthoFlight"),
    id: z.string(),
    include: orthoFlightOptions,
})

export const pdf = z.object({
    type: z.literal("pdf"),
    id: z.string(),
})

export const perimeter = z.object({
    type: z.literal("perimeter"),
    id: z.string(),
})

export const line = z.object({
    type: z.literal("line"),
    id: z.string(),
})

export const icon = z.object({
    type: z.literal("icon"),
    id: z.string(),
})

export const transferable = z.discriminatedUnion("type", [
    infraredFlight,
    orthoFlight,
    pdf,
    perimeter,
    line,
    icon,
])
export type Transferable = z.infer<typeof transferable>
